import { Injectable, EventEmitter, Output } from '@angular/core';
import { Client } from '../../models/client';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  @Output() auth0ClientDataIncomingEvent = new EventEmitter<Client[]>();

  constructor() {}
}
